import { createReducer } from "actionware";
import { createState } from "stateware";
import {
  toggleApplicationApprovalModal,
  getApplication,
  approvalModalDetail,
  resetApplication,
  toggleAppDetail,
  getBorrowerDetails,
} from "./applicationApprovalActions";
import _ from "lodash";

const initialState = createState({
  showingApplicationApprovalModal: false,
  action: "approve",
  applications: {},
  productBorrowerMapping: {},
});

export default createReducer(initialState)
  .on(toggleApplicationApprovalModal, (state, action) => {
    return initialState.copy({
      ...state,
      showingApplicationApprovalModal: !state.showingApplicationApprovalModal,
      action,
    });
  })
  .on(toggleAppDetail, (state, action) => {
    return initialState.copy({
      ...state,
      action,
    });
  })
  .on(getApplication, (state, applications) => {
    return initialState.copy({ ...state, applications });
  })
  .on(approvalModalDetail, (state, content) => {
    return initialState.copy({ ...state, modalContent: content });
  })
  .on(resetApplication, (state, action) => {
    return initialState;
  })

  .on(getBorrowerDetails, (state, data) => {
    let productBorrowerMapping = _.cloneDeep(state.productBorrowerMapping);
    if (data.product_code in productBorrowerMapping) {
      productBorrowerMapping[data.product_code][data.borrower_id] = {
        name: data.borrower_name,
        score: data.score
      }
    } else {
      productBorrowerMapping[data.product_code] = {
        [data.borrower_id]:  { 
          name : data.borrower_name,
          score: data.score
      }
    };
  }
    return initialState.copy({ ...state, productBorrowerMapping });
  });
